import TooltipPattern from "@/common/components/TooltipPattern";
import { BillingEventData } from "@/common/types/billing/event.type";
import { formatCurrency } from "@/common/utils/formatters";
import { transformToNumber } from "@/common/utils/transformers";
import { X } from "lucide-react";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { EventFeeTable } from "./components/EventFeeTable";

type TotalFeeProps = {
  data: BillingEventData;
  kind?: 'client' | 'establishment';
};

const CompanyEventTotalFee = ({ data: event, kind = 'client' }: TotalFeeProps) => {
  const [hoveredElement, setHoveredElement] = useState<HTMLElement | null>(null);
  
  const totalFee = transformToNumber({ 
    value: kind === 'client' ? event.fee_total : event.related_events_fee_total, 
    invert: true
  });

  const hasTotalFee = totalFee !== 0;

  const eventsIds = kind === 'client' 
    ? [event.id] 
    : (event.related_event_ids || []);

  const hasEventsIds = eventsIds.length > 0

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    if (hasTotalFee && hasEventsIds) {
      setHoveredElement(e.currentTarget as HTMLElement);
    }
  };

  const handleCloseTooltip = () => {
    setHoveredElement(null);
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleCloseTooltip}>
      <div className={twMerge("cursor-default py-4", totalFee > 0 ? 'text-valid' : totalFee < 0 ? 'text-danger-soft' : '')}>
        {formatCurrency(Number(totalFee))}
      </div>

      {hoveredElement && hasTotalFee && hasEventsIds && (
        <TooltipPattern target={hoveredElement} expectedWidth={350} expectedHeight={250}>
          <div className="bg-white-200 rounded-lg overflow-hidden border-gray-300 shadow-lg">
            <div className="bg-[#5A5D5F] flex items-center justify-between gap-2 p-6">
              <p className="text-[18px]">Detalhamento de tarifas</p>

              <div className="cursor-pointer" onClick={handleCloseTooltip}>
                <X className="h-6 w-6" color="red" />
              </div>
            </div>

            <div className="bg-[#2c2c2c]">
              <div className="bg-[#2c2c2c] max-h-[350px] overflow-y-auto">
                
              {eventsIds.map((id) => (
                <EventFeeTable key={id} eventId={id} />
              ))}

              </div>
            </div>
          </div>
        </TooltipPattern>
      )}
    </div>
  );
};

export default CompanyEventTotalFee;